import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrmLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 77,
	height: 24,
	viewBox: "0 0 77 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "ÐÑÐ³Ð°Ð½ÑÐ·Ð°ÑÑÑ",
		children: /* @__PURE__ */ _jsx("g", {
			id: "ÐÑÐ³Ð°Ð½ÑÐ·Ð°ÑÑÑ | Ð¡Ð¿ÑÐ²ÑÐ¾Ð±ÑÑÐ½Ð¸ÐºÐ¸",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Frame 1948755679",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Frame 1948754564",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Frame 1948754560",
						children: /* @__PURE__ */ _jsx("g", {
							id: "<Autocomplete>",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Frame 1948755837",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Frame 1948755836",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Logo_all",
										children: [/* @__PURE__ */ _jsx("g", {
											id: "Frame 1948755629",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Union",
												d: "M9.64062 12.8184C10.4917 12.8186 11.1814 13.5083 11.1816 14.3594V19.458C11.1816 20.3093 10.4918 20.9998 9.64062 21H4.54199C3.69058 21 3 20.3094 3 19.458V14.3594C3.00023 13.5082 3.69072 12.8184 4.54199 12.8184H9.64062ZM21 12.8594C20.9999 17.3547 17.3372 20.9999 12.8184 21V12.8184H20.999C20.999 12.8317 21 12.8461 21 12.8594ZM9.64062 3C10.4918 3.00023 11.1816 3.69072 11.1816 4.54199V11.1816C7.36869 11.1816 4.16566 9.62444 3.25781 7.51758C3.09528 7.27332 3.00001 6.98043 3 6.66504V4.54199C3 3.69058 3.69058 3 4.54199 3H9.64062ZM16.9092 3C19.1685 3.00005 21 4.83154 21 7.09082C21 9.35014 19.1685 11.1816 16.9092 11.1816C14.6498 11.1816 12.8184 9.35017 12.8184 7.09082C12.8184 4.83151 14.6499 3 16.9092 3Z",
												fill: "url(#paint0_linear_3_86)"
											})
										}), /* @__PURE__ */ _jsxs("g", {
											id: "CRM",
											children: [
												/* @__PURE__ */ _jsx("path", {
													id: "Vector",
													d: "M73.9751 4.76099H76.8679V19.986H74.4101V8.08874L69.7121 15.1792H69.4729L64.7966 8.08874V19.986H62.3389V4.76099H65.2316L69.6034 11.3295L73.9751 4.76099Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_2",
													d: "M56.9692 19.986L52.6193 14.3092H50.2703V19.986H47.8125V4.76099H54.0983C57.4043 4.76099 59.2748 6.71849 59.2748 9.58949C59.2748 12.0907 57.861 13.722 55.4468 14.1787L59.9925 19.986H56.9692ZM50.2703 7.10999V12.1342H53.8373C55.86 12.1342 56.7953 11.0902 56.7953 9.61124C56.7953 8.13224 55.8383 7.10999 53.8373 7.10999H50.2703Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_3",
													d: "M37.8518 20.247C33.3278 20.247 30 16.8758 30 12.3735C30 7.87125 33.3278 4.5 37.8518 4.5C41.3753 4.5 44.181 6.6315 45.138 9.78525H42.5063C41.7015 8.00175 39.9833 6.849 37.83 6.849C34.7198 6.849 32.4795 9.198 32.4795 12.3735C32.4795 15.549 34.7198 17.898 37.83 17.898C39.9833 17.898 41.7015 16.7453 42.5063 14.9618H45.138C44.181 18.1155 41.3753 20.247 37.8518 20.247Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												})
											]
										})]
									})
								})
							})
						})
					})
				})
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3_86",
		x1: 20.9601,
		y1: 16.9089,
		x2: 12.7786,
		y2: 16.9089,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .00124008,
			stopColor: "#4B1DF4"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#A19AF8"
		})]
	}) })]
});
export default SvgCrmLogo;
